import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { apiLongRunningRequestTimeoutMs } from "../config";
import useApiHelper from "../hooks/useApiHelper";
import { IDashboardStatsResponse } from "../models/DashboardStats";

export default function useDashboardStats() {
  const { get } = useApiHelper({ timeoutMs: apiLongRunningRequestTimeoutMs });
  const staleTime = 1000 * 60 * 1; // 1 minute
  const today = DateTime.now();
  const toDate = today.toISODate() ?? "";
  const fromWeek = today.startOf("week").toISODate() ?? "";
  const fromMonth = today.startOf("month").toISODate() ?? "";
  const from30 = today.minus({ days: 29 }).toISODate() ?? "";
  const fromYear = today.minus({ days: 364 }).toISODate() ?? "";

  const todayStats = useQuery({
    queryKey: ["dashboardStats", "range", toDate, toDate],
    queryFn: () => get<IDashboardStatsResponse>(`/stats/range?from=${encodeURIComponent(toDate)}&to=${encodeURIComponent(toDate)}`),
    staleTime: staleTime,
    retry: 1,
  });

  const last30DaysStats = useQuery({
    queryKey: ["dashboardStats", "range", from30, toDate],
    queryFn: () => get<IDashboardStatsResponse>(`/stats/range?from=${encodeURIComponent(from30)}&to=${encodeURIComponent(toDate)}`),
    staleTime: staleTime,
    retry: 1,
  });

  const weekToDateStats = useQuery({
    queryKey: ["dashboardStats", "range", fromWeek, toDate],
    queryFn: () => get<IDashboardStatsResponse>(`/stats/range?from=${encodeURIComponent(fromWeek)}&to=${encodeURIComponent(toDate)}`),
    staleTime: staleTime,
    retry: 1,
  });

  const monthToDateStats = useQuery({
    queryKey: ["dashboardStats", "range", fromMonth, toDate],
    queryFn: () => get<IDashboardStatsResponse>(`/stats/range?from=${encodeURIComponent(fromMonth)}&to=${encodeURIComponent(toDate)}`),
    staleTime: staleTime,
    retry: 1,
  });

  const lastYearStats = useQuery({
    queryKey: ["dashboardStats", "range", fromYear, toDate],
    queryFn: () => get<IDashboardStatsResponse>(`/stats/range?from=${encodeURIComponent(fromYear)}&to=${encodeURIComponent(toDate)}`),
    staleTime: staleTime,
    retry: 1,
  });

  return {
    todayStats,
    weekToDateStats,
    monthToDateStats,
    last30DaysStats,
    lastYearStats,
  };
}
